import styled from 'styled-components';
import COLORS from '../../common/styles/color-pallete';
import DEVICES from '../../common/styles/devices';
import { FONT_FAMILY } from '../../common/styles/fontStyles';

export const DownloadWrapper = styled.div`
  margin-top: 36px;
  min-width: 727px;
  background-color: ${COLORS.dividerBlue};
  box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.1);
  border-radius: 12px;
  display: flex;
  @media ${DEVICES.tab} {
    min-width: unset;
    margin: 24px 20px 0px 20px;
  }
  @media ${DEVICES.mobileXL} {
    min-width: unset;
    margin: 24px 20px 0px 20px;
  }
`;

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
`;

export const Title = styled.div`
  font-family: ${FONT_FAMILY.hellix.bold};
  font-size: 18px;
  line-height: 26px;
  @media ${DEVICES.mobileXL} {
    line-height: unset;
  }
`;

export const SubHeading = styled.div`
  font-family: ${FONT_FAMILY.hellix.regular};
  font-size: 16px;
  line-height: 22px;
`;

export const TitleWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  margin-left: 22px;
  @media ${DEVICES.mobileXL} {
    padding: 15px 8px 15px 0;
    margin-left: 12px;
  }
`;

export const ImageWrapper = styled.div`
  margin-left: 24px;
  margin-top: 9px;
  @media ${DEVICES.mobileXL} {
    display: none;
  }
  & > img {
    width: 127px;
    height: 87px;
  }
`;

export const MobileImageWrapper = styled.div`
  margin-left: 16px;
  margin-top: 15px;
  display: none;
  @media ${DEVICES.mobileXL} {
    display: block;
  }
  & > img {
    width: 104px;
    height: 106px;
  }
`;

export const ScanWrapper = styled.div`
  align-self: flex-end;
  width: 229px;
  height: 96px;
  background: ${COLORS.white};
  border-radius: 100px 12px 12px 100px;
  display: flex;
  align-items: center;
  margin-left: 60px;
  @media ${DEVICES.tab} {
    margin-left: 10px;
  }
  @media ${DEVICES.mobileXL} {
    display: none;
  }
`;

export const QRWrapper = styled.div`
  margin-left: 42px;
`;
export const DownloadTitle = styled.div`
  font-family: ${FONT_FAMILY.hellix.regular};
  font-size: 10px;
  line-height: 12px;
  padding: 0 12px 0 24px;
`;
export const ButtonWrapper = styled.div`
  display: none;
  margin-top: 8px;
  @media ${DEVICES.mobileXL} {
    display: block;
  }
`;
export const AppStoreImage = styled.img`
  cursor: pointer;
  width: 82px;
  height: 24px;
`;
export const PlayStoreImage = styled.img`
  margin-left: 6px;
  width: 82px;
  height: 24px;
  cursor: pointer;
  @media ${DEVICES.mobileM} {
    margin-left: 0;
  }
`;
export const QRCodeWrapper = styled.img`
  width: 54px;
  height: 54px;
`;
export const GreyBox = styled.div`
  display: flex;
  align-items: center;
  font-size: 14px;
  line-height: 18x;
  font-family: ${FONT_FAMILY.hellix.regular};
  margin-top: 16px;
  border: 1px solid ${COLORS.lightShadedGrey};
  background-color: ${COLORS.lightGrey};
  border-radius: 8px;
  padding: 12px 16px;
  .image-mobile {
    margin-right: 12px;
  }
  .text {
    color: ${COLORS.textGrey};
    font-size: 14px;
    line-height: 18px;
  }
`;
export const DateWrapper = styled.span`
  display: flex;
  align-items: center;
  .recurring-icon {
    margin-left: 10px;
  }
  .date-icon {
    display: flex;
    align-items: center;
  }
`;

export const RfiAlertContainer = styled.div`
  margin-top: 36px;
  display: flex;
  min-width: 727px;
  align-items: flex-start;
  background-color: ${COLORS.lightOrange};
  border: 1px solid ${COLORS.orange};
  padding: 16px;
  border-radius: 10px;

  @media ${DEVICES.tab} {
    min-width: 453px;
    margin: 24px 20px 0px 20px;
  }
  @media ${DEVICES.mobileL} {
    min-width: 332px;
    margin: 24px 20px 0px 20px;
  }
`;

export const TextWrapper = styled.div`
  display: flex;
  flex-direction: column;
  padding-left: 12px;

  .heading {
    font-family: ${FONT_FAMILY.hellix.bold};
    font-size: 14px;
    line-height: 22px;
    color: ${COLORS.black};
  }
  .sub-heading {
    font-family: ${FONT_FAMILY.hellix.regular};
    font-size: 14px;
    line-height: 22px;
    color: ${COLORS.textGrey};
  }
`;
